import {Injectable} from '@angular/core';
import {DialogService, Toast} from "../../components/dialog/dialog.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(
        private dialogService: DialogService,
        private translateService: TranslateService,
    ) {
    }

    /**
     * Danger notification
     *
     * @param data
     */
    danger(data: Toast) {
        // TODO: customize data, colors, etc..
        return this.dialogService.toast({
            action: this.translateService.instant('global.buttons.close'),
            ...data,
            position: {
                horizontal: "end",
                vertical: "top"
            }
        })
    }

    /**
     * Success notification
     *
     * @param data
     */
    success(data: Toast) {
        // TODO: customize data, colors, etc..
        return this.dialogService.toast({
            ...data,
            position: {
                horizontal: "end",
                vertical: "top"
            },
            duration: 3000
        })
    }

    /**
     * Info notification
     *
     * @param data
     */
    info(data: Toast) {
        // TODO: customize data, colors, etc..
        return this.dialogService.toast({
            ...data,
            position: {
                horizontal: "end",
                vertical: "top"
            },
            duration: 3000
        })
    }
}
